import React from 'react'
import { useTranslation } from 'react-i18next'
import { authActions } from 'core/actions/auth'
import { useDispatch } from 'react-redux'
import { getApi } from 'core/api'
import { useAppSelector } from 'core/hooks'
import { history } from 'helpers'
import { Menu, Dropdown, Button } from 'antd'
import { Link } from 'react-router-dom'
import Icon from 'elements/Icon'
import './header.css'
import { AtomInstance, SearchTextInput } from '../SearchTextInput'
import { SearchDescriptor } from 'api/extra/model/search-descriptor'
import { User } from '../../api/model/User'

interface HeaderProps {
  search: (descriptor: SearchDescriptor, tags?: AtomInstance[]) => void
}

function Header({ search }: HeaderProps): JSX.Element {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { iccapi, user } = useAppSelector((state) => ({
    iccapi: state.auth.user && getApi(state.auth.user),
    user: state.auth.user,
  }))

  const handleLogout = () => {
    iccapi?.userApi && dispatch(authActions.logout(iccapi?.userApi))
    history.push('/login')
  }

  const menu = (
    <Menu>
      <Menu.Item key={'user'}>
        <Link to="/" className="profile__link">
          <div className="ml-2">
            {/*TODO: name is not observing change, it needs a refresh to reflect the updated values*/}
            <h6 className="h-6">{user ? user.username : '-'}</h6>
          </div>
        </Link>
      </Menu.Item>
      <Menu.Item key={'logout'} onClick={() => handleLogout()}>
        <Button className="btn empty btn-into-dropdown">
          <Icon name="logout" />
          <span>{t('Header.logout')}</span>
        </Button>
      </Menu.Item>
    </Menu>
  )
  return (
    <div className="header">
      <div className="container-fluid-docked-left">
        <div className="header__inner">
          <div className="flex-center grow-1 mt-1 ml-1 mb-1">
            <SearchTextInput
              onSearch={(x, tags) => {
                search(x, tags)
              }}
            />
          </div>
          <div className="header__profile">
            <Dropdown overlay={menu}>
              <div className="profile__name">
                <span>{user?.username}</span>
                <Icon name="arrow-down" />
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
